module.exports = __webpack_public_path__ + "static/torun-99cddeddf9293b53f94adc683e998e18.png";